import { useTranslation } from 'react-i18next';
import { InputGroup } from '../../common/InputGroup';
import { DropdownTypeahead } from '../../common/DropdownTypeahead';
import { City } from '../../../types/profile';

interface PersonalInfoSectionProps {
  firstName: string;
  lastName: string;
  phone: string;
  cityQuery: string;
  cityOptions: City[];
  onFirstNameChange: (value: string) => void;
  onLastNameChange: (value: string) => void;
  onPhoneChange: (value: string) => void;
  onCitySelect: (city: City | null) => void;
  errors: {
    firstName?: string;
    lastName?: string;
    city?: string;
    phone?: string;
  };
}

export const PersonalInfoSection: React.FC<PersonalInfoSectionProps> = ({
  firstName,
  lastName,
  phone,
  cityQuery,
  cityOptions,
  onFirstNameChange,
  onLastNameChange,
  onPhoneChange,
  onCitySelect,
  errors,
}) => {
  const { t } = useTranslation('auth');

  return (
    <>
      <InputGroup
        label={t('firstName')}
        value={firstName}
        onChange={e => onFirstNameChange(e.target.value)}
        placeholder={t('firstNamePlaceholder')}
        required
        error={!!errors.firstName}
        errorMessage={errors.firstName}
      />
      <InputGroup
        label={t('lastName')}
        value={lastName}
        onChange={e => onLastNameChange(e.target.value)}
        placeholder={t('lastNamePlaceholder')}
        required
        error={!!errors.lastName}
        errorMessage={errors.lastName}
      />
      <InputGroup label={t('city')} required error={!!errors.city} errorMessage={errors.city}>
        <DropdownTypeahead
          className="mt-2"
          value={cityQuery || ''}
          onChange={(_val: string, item?: City) => {
            onCitySelect(item ?? null);
          }}
          options={cityOptions}
          getOptionLabel={item => item.name}
          getOptionValue={item => item.id}
          placeholder={t('cityPlaceholder')}
          showDropdownIcon={false}
          error={!!errors.city}
        />
      </InputGroup>
      <InputGroup
        label={t('phone')}
        value={phone}
        onChange={e => onPhoneChange(e.target.value)}
        placeholder={t('phonePlaceholder')}
        required
        error={!!errors.phone}
        errorMessage={errors.phone}
      />
    </>
  );
};
